// extracted by mini-css-extract-plugin
module.exports = {"bi-chevron-down":"ProductContainer_bi-chevron-down__F9wwT","productsContainer":"ProductContainer_productsContainer__3-Jm3"};